<template>
  <section>
    <div class="section_title p-0">
      <img src="@/assets/img/news_sub.jpg" />
      <h1 class="">会員通信</h1>
    </div>
    <div>
      <dl class="list-news">
        <template v-for="(info, i) in displayNews" :key="i">
          <dt>{{ info.date }}</dt>
          <dd v-html="info.html" />
        </template>
      </dl>
      <div class="jPageholder my-5">
        <a @click="prev" class="jp-previous jp-disabled">前頁</a>
        <a
          @click="go(page)"
          v-for="page of maxPage"
          :key="page"
          :class="[page == currentPage ? 'jp-current' : '']"
          >{{ page }}</a
        >
        <!-- <a class="jp-current">1</a> -->
        <!-- <span class="jp-hidden">...</span> -->
        <a @click="next" class="jp-next">次頁</a>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();

export default {
  data() {
    return {
      informations: [], // 全てのニュース
      displayNews: [], // 表示するニュース
      currentPage: 0, // 現在のページ
      maxPage: 0, // 最大ページ
      pageLines: 10, // 1ページに表示する行数
      shopping: true,
    };
  },
  computed: {
    isManager() {
      return this.$store.state.isManager;
    },
  },
  mounted() {
    window.scroll(0, 0);
    this.shopping = auth.getShopping();
    axios
      .get(process.env.VUE_APP_CONTENTS_INFORMATION_HOME + "index.json")
      .then((res) => {
        if (this.shopping) {
          this.informations = res.data.filter(function (info) {
            return info.isShopping;
          });
        } else if (this.isManager) {
          this.informations = res.data;
        } else {
          this.informations = res.data.filter(function (info) {
            if (!(info.isManager || info.isShopping)) {
              return true;
            } else {
              return false;
            }
          });
        }
        this.currentPage = 1;
        // maxページを求める
        this.maxPage = Math.ceil(this.informations.length / this.pageLines);
        this.go(1);
      })
      .catch(() => {
        console.log("お知らせが読み取れません");
      });
  },
  methods: {
    go(page) {
      this.currentPage = page;
      // 表示するリストの切り取り
      const endIndex = page * this.pageLines;
      const startIndex = endIndex - this.pageLines;
      this.displayNews = this.informations.slice(startIndex, endIndex);
    },
    next() {
      if (this.currentPage == this.maxPage) return;
      this.go(this.currentPage + 1);
    },
    prev() {
      if (this.currentPage == 1) return;
      this.go(this.currentPage - 1);
    },
  },
};
</script>

<style scoped>
.list-news dt {
  float: left;
  width: 120px;
  padding-top: 17px;
  letter-spacing: 0.1em;
  font-family: "proxima-nova", sans-serif;
}
.list-news dd {
  padding: 17px 0 17px 150px;
  border-bottom: 1px solid #eee;
}
@media screen and (min-width: 1px) and (max-width: 991px) {
  .list-news dt {
    width: 100%;
  }
  .list-news dd {
    padding: 0 0 15px;
  }
}
</style>
